import React from 'react';

const StartSvg = () => {
    return (
        <svg width="136" height="24" viewBox="0 0 136 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_24001_178254)">
                <path
                    d="M11.9996 18.4999L17.0743 21.5691C18.0036 22.1316 19.1408 21.3001 18.8963 20.2485L17.5512 14.4768L22.0389 10.5883C22.8582 9.8791 22.4179 8.53401 21.3419 8.44841L15.4357 7.94706L13.1246 2.49334C12.7089 1.50287 11.2904 1.50287 10.8747 2.49334L8.56355 7.93483L2.65739 8.43618C1.58132 8.52178 1.14111 9.86687 1.96039 10.5761L6.44809 14.4646L5.10301 20.2363C4.85845 21.2879 5.99566 22.1194 6.92499 21.5569L11.9996 18.4999Z"
                    fill="#FFA000"
                />
            </g>
            <g clip-path="url(#clip1_24001_178254)">
                <path
                    d="M39.9996 18.4999L45.0743 21.5691C46.0036 22.1316 47.1408 21.3001 46.8963 20.2485L45.5512 14.4768L50.0389 10.5883C50.8582 9.8791 50.4179 8.53401 49.3419 8.44841L43.4357 7.94706L41.1246 2.49334C40.7089 1.50287 39.2904 1.50287 38.8747 2.49334L36.5635 7.93483L30.6574 8.43618C29.5813 8.52178 29.1411 9.86687 29.9604 10.5761L34.4481 14.4646L33.103 20.2363C32.8584 21.2879 33.9957 22.1194 34.925 21.5569L39.9996 18.4999Z"
                    fill="#FFA000"
                />
            </g>
            <g clip-path="url(#clip2_24001_178254)">
                <path
                    d="M67.9996 18.4999L73.0743 21.5691C74.0036 22.1316 75.1408 21.3001 74.8963 20.2485L73.5512 14.4768L78.0389 10.5883C78.8582 9.8791 78.4179 8.53401 77.3419 8.44841L71.4357 7.94706L69.1246 2.49334C68.7089 1.50287 67.2904 1.50287 66.8747 2.49334L64.5635 7.93483L58.6574 8.43618C57.5813 8.52178 57.1411 9.86687 57.9604 10.5761L62.4481 14.4646L61.103 20.2363C60.8584 21.2879 61.9957 22.1194 62.925 21.5569L67.9996 18.4999Z"
                    fill="#FFA000"
                />
            </g>
            <g clip-path="url(#clip3_24001_178254)">
                <path
                    d="M95.9996 18.4999L101.074 21.5691C102.004 22.1316 103.141 21.3001 102.896 20.2485L101.551 14.4768L106.039 10.5883C106.858 9.8791 106.418 8.53401 105.342 8.44841L99.4357 7.94706L97.1246 2.49334C96.7089 1.50287 95.2904 1.50287 94.8747 2.49334L92.5635 7.93483L86.6574 8.43618C85.5813 8.52178 85.1411 9.86687 85.9604 10.5761L90.4481 14.4646L89.103 20.2363C88.8584 21.2879 89.9957 22.1194 90.925 21.5569L95.9996 18.4999Z"
                    fill="#FFA000"
                />
            </g>
            <g clip-path="url(#clip4_24001_178254)">
                <path
                    d="M124 18.4999L129.074 21.5691C130.004 22.1316 131.141 21.3001 130.896 20.2485L129.551 14.4768L134.039 10.5883C134.858 9.8791 134.418 8.53401 133.342 8.44841L127.436 7.94706L125.125 2.49334C124.709 1.50287 123.29 1.50287 122.875 2.49334L120.564 7.93483L114.657 8.43618C113.581 8.52178 113.141 9.86687 113.96 10.5761L118.448 14.4646L117.103 20.2363C116.858 21.2879 117.996 22.1194 118.925 21.5569L124 18.4999Z"
                    fill="#FFA000"
                />
            </g>
            <defs>
                <clipPath id="clip0_24001_178254">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
                <clipPath id="clip1_24001_178254">
                    <rect width="24" height="24" fill="white" transform="translate(28)" />
                </clipPath>
                <clipPath id="clip2_24001_178254">
                    <rect width="24" height="24" fill="white" transform="translate(56)" />
                </clipPath>
                <clipPath id="clip3_24001_178254">
                    <rect width="24" height="24" fill="white" transform="translate(84)" />
                </clipPath>
                <clipPath id="clip4_24001_178254">
                    <rect width="24" height="24" fill="white" transform="translate(112)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default StartSvg;
